export const removeMaskCPF = (value: string) => {
  if (!value || typeof value !== 'string') return '';
  return value.replace(/\D/g, "");
};

// Função para validar formato de CPF
export const validateCPFFormat = (cpf: string): boolean => {
  // Verifica se o CPF tem pelo menos 11 dígitos
  if (cpf.length < 11) return false;

  // Verifica se o CPF está no formato correto (000.000.000-00)
  return /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(cpf);
};

// Função para validar formato de CNPJ
export const validateCNPJFormat = (cnpj: string): boolean => {
  // Verifica se o CNPJ tem pelo menos 14 dígitos
  if (cnpj.length < 14) return false;

  // Verifica se o CNPJ está no formato correto (00.000.000/0000-00)
  return /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(cnpj);
};

// Função para validar formato de documento (CPF ou CNPJ)
export const validateDocumentFormat = (document: string): boolean => {
  return validateCPFFormat(document) || validateCNPJFormat(document);
};

// Função para validar formato de token
export const validateCodeFormat = (code: string): boolean => {
  // Verifica se o token tem exatamente 6 dígitos numéricos
  return code.length === 6 && /^\d{6}$/.test(code);
};

